import {Button, styled} from "@mui/material";

export const TableTabsContainer = styled("div")({
    // backgroundColor: 'red',
    display: "flex",
    position: "relative",
    // minHeight: '30px',
    // borderBottom: '1px solid #DCDCDC',
    // overflowX: "auto",
    // overflowY: "hidden",
    width: "fit-content",
    whiteSpace: "nowrap",
});
export const TableTabsWrapper = styled("div")({
    // width: "100%",
    // marginTop: '55px',
    // overflowY: "hidden",
    // overflowX: "auto",
});

interface TabCellType {
    active?: boolean;
}

export const TabCell = styled(Button)<TabCellType>(({theme, active}) => ({
    // width: '120px',
    width: "auto",
    minHeight: "48px",
    height: "fit-content",
    fontWeight: active ? "bold" : "normal",
    fontSize: "12px",
    color: active ? theme.palette.primary.main : "#8F8F8F",
    cursor: "pointer",
    padding: "0 24px",
}));

interface ThumbType {
    right?: number;
    width?: number;
}

export const Thumb = styled("div")<ThumbType>(({theme, right, width}) => ({
    width: `${width}px`,
    right: `${right ?? 0}px`,
    marginRight: "15px",
    transition: "all 0.3s",
    height: "3px",
    backgroundColor: theme.palette.primary.main,
    position: "absolute",
    bottom: 0,
    borderRadius: 5,
}));
